export const decodeJWTPayload = (jwt?: string) => {
  if (!jwt) {
    return;
  }
  try {
    const base64Url = jwt.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(
      window
        .atob(base64)
        .split('')
        .map(function (c) {
          return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        })
        .join('')
    );
    return JSON.parse(jsonPayload);
  } catch (e) {
    console.error(
      '@clientos-commons-northbound-api - decodeJWTPayload - error parsing: ',
      e?.message ?? e
    );
    return undefined;
  }
};
